export type StripeCheckout = {
	description: string;
	productId: string;
	planId: number;
	purchaseMode?: string;
	successUrl: string;
	failureUrl: string;
	checkoutMode?: "EMBED" | "HOSTED";
};

const createCheckoutSession = async (_payment: StripeCheckout) => {
	return {
		clientSecret: "",
	};
};

export default createCheckoutSession;
